import ProjectTables from "../../components/dashboard/ProjectTable";
import StudentDocsTable from "../../components/StudentDocsTable";
import { Row, Col, Table, Card, CardTitle, CardBody } from "reactstrap";

const StudentTables = () => {
  return (
    <Row>
      {/* --------------------------------------------------------------------------------*/}
      {/* table-1*/}
      {/* --------------------------------------------------------------------------------*/}
    {/*   <Col lg="12">
        <ProjectTables />
      </Col> */}
      {/* --------------------------------------------------------------------------------*/}
      {/* table-2*/}
      {/* --------------------------------------------------------------------------------*/}
      <Col lg="12">
        <Card>
          <CardTitle tag="h6" className="border-bottom p-3 mb-0">
            <i className="bi bi-card-text me-2"> </i>
            Pending Student Applications
          </CardTitle>
          <CardBody className="">

            <StudentDocsTable/>
    
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default StudentTables;
